export class ServiceWorker {
	// constructor() {}

	register = async (path = '/sw.js', registerOptions = { scope: '/' }) => {
		if (!('serviceWorker' in navigator)) return console.log('[SW] Not Support');

		const options = registerOptions || { scope: '/' };

		try {
			const registration = await navigator.serviceWorker.register(path, options);

			console.log(`[SW] Registered In Scope: ${registration.scope}`);

			return registration;
		} catch (err) {
			console.log('[SW] Registeration Error ', err);
			return null;
		}
	};
}
